import Vue from 'vue'
import VueNativeSock from 'vue-native-websocket'
import store from '@/system/store'

const { VUE_APP_WEBSOCKET_URL } = process.env

Vue.use(VueNativeSock, VUE_APP_WEBSOCKET_URL, {
  format: 'json',
  store,
  connectManually: true,
  reconnectionAttempts: 5,
  reconnection: true,
  reconnectionDelay: 3000,
  passToStoreHandler: function (eventName: string, event: any) {
    if (!eventName.startsWith('SOCKET_')) { return }
    let method = 'commit'
    let target = eventName.toUpperCase()
    let msg = event
    const { data } = event

    if (this.format === 'json' && data) {
      const { mutation, action, namespace = '', ...rest } = JSON.parse(data)
      msg = rest
      if (mutation) {
        target = [namespace, mutation].filter(Boolean).join('/')
      } else if (action) {
        method = 'dispatch'
        target = [namespace, action].filter(Boolean).join('/')
      }
    }
    this.store[method](target, msg)
  }
})
